import { render, staticRenderFns } from "./SupportAndServices.vue?vue&type=template&id=a86946d4&scoped=true&"
import script from "./SupportAndServices.vue?vue&type=script&lang=js&"
export * from "./SupportAndServices.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/project-manage.css?vue&type=style&index=0&id=a86946d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86946d4",
  null
  
)

export default component.exports